import React from "react";
import { Button, Descriptions, Drawer, Space, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { formatAnswerOptions, formatLongDateTime, statusColor } from "./utils";

export default function SampleQuestionDetailsDrawer({
  open,
  onClose,
  question,
  onEdit,
}) {
  return (
    <Drawer
      title="Sample Question"
      width={760}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      extra={
        onEdit ? (
          <Button icon={<EditOutlined />} type="primary" onClick={() => onEdit(question)}>
            Edit
          </Button>
        ) : null
      }
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="ID">{question?.id || "-"}</Descriptions.Item>
          <Descriptions.Item label="Question">{question?.question || "-"}</Descriptions.Item>
          <Descriptions.Item label="Answer Type">
            <Tag color="green">{question?.answerType || "-"}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Answer Value Type">
            <Tag color={statusColor(question?.answerValueType)}>{question?.answerValueType || "-"}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Answer Metric">{question?.answerMetric || "-"}</Descriptions.Item>
          <Descriptions.Item label="Answer Options">
            {formatAnswerOptions(question?.answerOptions).length ? (
              <Space wrap>
                {formatAnswerOptions(question?.answerOptions).map((option) => (
                  <Tag key={option}>{option}</Tag>
                ))}
              </Space>
            ) : (
              "-"
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {formatLongDateTime(question?.createdAt)}
          </Descriptions.Item>
          <Descriptions.Item label="Updated At">
            {formatLongDateTime(question?.updatedAt)}
          </Descriptions.Item>
        </Descriptions>
      </Space>
    </Drawer>
  );
}
